import React from 'react'
import successIcon from '../app/webcomponents/assets/images/success.svg'
import errorIcon from '../app/webcomponents/assets/images/generic/empty-states_illustration_error.svg'

const FinalizeConfiguration = ({companyName, isWizardCompleted}) => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <div className='mt-56 mb-2 flex flex-row align-middle justify-center items-center'>
        <img src={isWizardCompleted ? successIcon: errorIcon} alt=''/>
      </div>
      <span className='font-semibold font-mono text-xl text-zinc-500'>{isWizardCompleted ? 'Success' : 'Warning'}</span>
      {isWizardCompleted && <gz-text fontSize="14">
        You've completed the Configuration process for <br/> <span className='font-semibold ml-12'>{companyName}</span> company.
      </gz-text>}
      {!isWizardCompleted && <gz-text fontSize="14">
        Tenant configuration data has been reset. Please complete the previous steps.
      </gz-text>}
    </div>

  )
}

export default FinalizeConfiguration